import { getSearchParam } from "@/lib/utils";
import { usersKeys } from "@/query-keys";
import { services } from "@/services";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { z } from "zod";

export const Route = createFileRoute("/_public/auth/callback")({
  validateSearch: (search) =>
    z
      .object({
        token: z.string().optional(),
        error: z.string().optional(),
      })
      .parse(search),

  beforeLoad: async ({ context }) => {
    const token = getSearchParam("token");
    if (!token) {
      throw redirect({ to: "/login" });
    }

    try {
      await services.verifyCallback(token);
      await context.queryClient.invalidateQueries({ queryKey: usersKeys.profile() });
      throw redirect({ to: "/" });
    } catch {
      throw redirect({ to: "/login" });
    }
  },

  component: AuthCallbackPage,
});

function AuthCallbackPage() {
  const { t } = useTranslation();

  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto mb-4" />
        <p className="text-muted-foreground text-sm">{t("auth.verifying")}</p>
      </div>
    </div>
  );
}
